import { Toaster as Sonner, toast } from "sonner"
import { createPortal } from "react-dom"
import { useEffect, useState } from "react"

const Toaster = ({
  ...props
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const toasterContent = (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-slate-900 group-[.toaster]:border-slate-200 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-slate-500",
          actionButton:
            "group-[.toast]:bg-blue-600 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-slate-100 group-[.toast]:text-slate-600",
        },
      }}
      {...props} 
    />
  );

  // Use portal-root if available, otherwise render inline
  if (mounted && typeof document !== 'undefined') {
    const portalRoot = document.getElementById('portal-root');
    if (portalRoot) {
      return createPortal(toasterContent, portalRoot);
    }
  }

  return toasterContent;
}

export { Toaster, toast }
